import { Component, OnInit } from "@angular/core";
declare var $: any;

@Component({
standalone: false,
  selector: "app-landing-nav",
  templateUrl: "./landing-nav.component.html",
  styleUrls: ["./landing-nav.component.scss"],
})
export class LandingNavComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    $("#ChangeToggle").click(function () {
      $("#navbar-hamburger").toggleClass("hidden");
      $("#navbar-close").toggleClass("hidden");
    });
  }
}
